import { Component } from 'preact';
import "image-comparison/src/ImageComparison.css";

import ploneApi from "api/PloneApi";

import { LinkHandlerContext } from 'components/Contexts';

export default class DocumentView extends Component {
    constructor(props) {
        super(props);

        this.state = {
            color: null
        }
    }

    updateColor() {
        if(this.props.item["@type"] !== "lkd-document") {
            this.setState({
                color: null
            });
            return;
        }

        ploneApi.getColor(this.props.item)
            .then(color => {
                this.setState({
                    color: color
                });
            })
            .catch(error => {
                this.setState({
                    color: null
                });
            });
    }

    initImageComparison() {
        const elems = this.content.querySelectorAll(".lkd-template.comparison-slider");
        Array.prototype.forEach.call(elems, elem => {
            const img1 = elem.querySelector(".image1 img").cloneNode();
            const img2 = elem.querySelector(".image2 img").cloneNode();

            img1.className = img2.className = "comparison-image";

            const title1 = img1.getAttribute("title");
            const title2 = img2.getAttribute("title");

            const wrapper = document.createElement("div");
            const innerWrapper = wrapper.cloneNode();
            wrapper.appendChild(innerWrapper);
            elem.parentNode.replaceChild(wrapper, elem);

            const comparison = new ImageComparison({
                container: innerWrapper,
                startPosition: 50,
                data: [
                    {
                        image: img1,
                        label: title1
                    },
                    {
                        image: img2,
                        label: title2
                    }
                ],
            });

            let loaded = 0;
            const loadCallback = () => {
                loaded++;
                if(loaded === 2) {
                    window.setTimeout(() => comparison._setImageSize(), 0);
                }
            };
            comparison.images[0].onload = comparison.images[1].onload = loadCallback;
        });
    }

    initWildcardMedia() {
        const elems = this.content.querySelectorAll(".lkd-template.wcmedia-video, .lkd-template.wcmedia-audio");
        Array.prototype.forEach.call(elems, elem => {
            const urlElem = elem.querySelector(".url");
            let url;

            if (urlElem.querySelector("a")) {
                // use either the href attribute if it is a link...
                url = urlElem.querySelector("a").getAttribute("href");
            } else {
                // or the text itself (it's hopefully an url)
                url = urlElem.textContent.trim();
            }

            let urlArray = url.split("/");
            if (urlArray[urlArray.length - 1] == "view") {
                urlArray.pop();
            }
            url = urlArray.join("/");

            if(elem.classList.contains("wcmedia-video")) {
                let width, height;
                if(elem.classList.contains('video-large')){
                    width = 720;
                    height = 480;
                }else if(elem.classList.contains('video-small')){
                    width = 320;
                    height = 240;
                }
                fetch(url + '/@@wildcard_video_macro')
                    .then(response => {
                        if(response.status !== 200) {
                            return;
                        }
                        return response.text();
                    })
                    .then(data => {
                        const newElem = document.createElement("div");
                        if(width && height){
                            data.querySelector('[width]').setAttribute('width', width);
                            data.querySelector('[height]').setAttribute('height', height);
                        }
                        newElem.innerHTML = data;
                        elem.parentNode.replaceChild(newElem, elem);
                    })
                    .catch(err => {
                        console.log('Fetch Error:', err);
                    });
            } else if(elem.classList.contains("wcmedia-audio")) {
                const mediaElem = document.createElement("audio");
                mediaElem.setAttribute("controls", "controls");
                mediaElem.setAttribute("preload", "none");
                mediaElem.setAttribute("src", url + '/@@view/++widget++form.widgets.IAudio.audio_file/@@download/file.mp3');

                elem.parentNode.replaceChild(mediaElem, elem);
            } else {
                return;
            }
        });
    }

    static replaceWithIframe(elem, url) {
        const iframeElem = document.createElement("iframe");
        iframeElem.onload = event => {
            iframeElem.style.height = Math.max(iframeElem.contentWindow.document.body.scrollHeight + 15, 250) + 'px';
        };
        iframeElem.setAttribute("src", url);
        iframeElem.setAttribute("scrolling", "no");
        iframeElem.setAttribute("frameborder", 0);
        iframeElem.setAttribute("border", 0);
        elem.parentNode.replaceChild(iframeElem, elem);
    }

    initIflEmbedding() {
        const elems = this.content.querySelectorAll(".lkd-template.ifl-embedding");
        Array.prototype.forEach.call(elems, elem => {
            const urlElem = elem.querySelector(".id");
            let url;

            if (urlElem.querySelector("a")) {
                // use either the href attribute if it is a link...
                url = urlElem.querySelector("a").getAttribute("href");
            } else {
                // or the text itself (it's hopefully an url)
                url = urlElem.textContent.trim();
            }

            url = ploneApi.publicPath + "/assets/ifl_maps/" + url;

            DocumentView.replaceWithIframe(elem, url);
        });
    }

    initInternalLinkEmbedding() {
        const elems = this.content.querySelectorAll("a[href^='" + ploneApi.serverBase + "'][href$='.html']");
        Array.prototype.forEach.call(elems, elem => {
            const url = elem.getAttribute("href");
            DocumentView.replaceWithIframe(elem, url);
        });
    }

    initInternalLinks() {
        const elems = this.content.querySelectorAll("a[href^='" + ploneApi.serverBase + "']");
        Array.prototype.forEach.call(elems, elem => {
            const url = elem.getAttribute("href");
            const newUrl = ploneApi.sanitizeUrl(url);

            elem.setAttribute("href", newUrl);
            elem.onclick = event => {
                event.preventDefault();
                this.openLink(newUrl);
            };
        });
    }

    initContentModifiers() {
        if (this.content) {
            this.initWildcardMedia();
            this.initImageComparison();
            this.initIflEmbedding();
            this.initInternalLinkEmbedding();
            this.initInternalLinks();
        }
    }

    componentDidMount() {
        this.initContentModifiers();
        this.updateColor();
    }

    componentDidUpdate(prevProps) {
        this.initContentModifiers();

        if(prevProps && prevProps.item["@id"] !== this.props.item["@id"]) {
            this.updateColor();
        }
    }

    renderTitle(className = null) {
        return (this.props.titleH2) ? <h2 className={ className }>{ this.props.item.title }</h2> : <h1>{ this.props.item.title }</h1>;
    }

    renderContent() {
        return (this.props.item.text == null) ? "" : (
            <div ref={ content => this.content = content } dangerouslySetInnerHTML={ { __html: this.props.item.text.data } } />
        );
    }

    render() {
        const color = this.state.color;

        return (
            <article>
                <LinkHandlerContext.Consumer>
                    { context => { this.openLink = context.openLink; return null; }}
                </LinkHandlerContext.Consumer>
                { this.renderTitle() }
                { color && <div className={ "color-"+color+" lkd-page-color grid-breakout" }/> }
                { this.renderContent() }
            </article>
        );
    }

}




// WEBPACK FOOTER //
// ./components/ContentViews/DocumentView.jsx